<ion-split-pane contentId="main">
  <div id="main" class="ion-page">
    <router-outlet></router-outlet>
  </div>
</ion-split-pane>
